import _ from 'lodash';

import AxiosService from '../utils/AxiosService';

import Config from '../config';

// Enums
export enum PlansEnum {
    Advanced = 'Advanced',
    Free = 'Free',
    Professional = 'Professional',
    Standard = 'Standard',
    Starter = 'Starter'
};

export enum PeriodicityEnum {
    Monthly = 'monthly',
    Annual = 'annual'
};

// Interfaces
export interface NewPaymentInterface {
    amount: number;
    brand?: string;
    currency: string;
    description: string;
    last4?: string;
    orderId: string;
    platform: string;
    type: string;
    planId: string;
};

export interface PaymentInterface extends NewPaymentInterface {
    _id: string;
    createdAt: string;
    endDate: string;
    receiptNumber: string;
    startDate: string;
    userId: string;
};

export interface PaymentIntent {
    amount: number
    currency: string
    periodic: boolean
    description: string
    paymentMethod: string
}

export interface StripePaymentIntent {
    id: string
    receipt_email: string
    client_secret: string
}

export interface NewSubscriptionInterface {
    planId: string;
    offerId?: string;
    amount: number;
    currency: string;
    paymentMethodId: any;
    platform: string;
    type: string;
}

export interface ConfirmSubscriptionInterface {
    orderId: string, // El id de la suscripción de stripe
    platform: string,
    type: string // o el tipo que corresponda
}

export interface SubscriptionInterface {
    _id: string;
    orderId: string;
    provider: string;
    startDate: string;
    type: string;
    userId: string;
    status: string;
    clientSecret: string;
};

export interface LicenseInterface {
    _id?: string;
    activeSubscription: boolean;
    endDate?: string;
    maxStudents: number;
    name: PlansEnum;
    startDate?: string;
    userId?: string;
};

export interface Plan {
    _id: string;
    name: string;
    logo: any;
    maxStudents: number;
    monthlyPrice: number;
    annualPrice: number;
    generalOffers: GeneralOffer[]
    expirationDate: string;
    createdAt: string;
    updatedAt?: string;
}

export interface GeneralOffer {
    _id: string;
    planId: string;
    discount: number;
    type: PeriodicityEnum;
    createdAt: string;
    updatedAt?: string;
}

export type AccountStatus = "INCOMPLETE" | "ACTIVE" | "PENDING_VERIFICATION";

const cancelSubscription = async (): Promise<void> => _.get(await AxiosService.deleting(Config.server.api.paymentApi + 'pro/subscription', true), 'data', {});
const createStripePaymentIntent = async (data: PaymentIntent): Promise<StripePaymentIntent> => _.get(await AxiosService.post(Config.server.api.paymentApi + 'pro/stripe/intent', data, true), 'data', {});
const createPayment = async (payload: NewPaymentInterface): Promise<PaymentInterface> => _.get(await AxiosService.post(Config.server.api.paymentApi + 'pro/payment', payload, true), 'data', {});
const createSubscription = async (payload: NewSubscriptionInterface): Promise<SubscriptionInterface> => _.get(await AxiosService.post(Config.server.api.paymentApi + 'pro/subscription', payload, true), 'data', {});
const confirmSubscription = async (payload: ConfirmSubscriptionInterface): Promise<SubscriptionInterface> => _.get(await AxiosService.post(Config.server.api.paymentApi + 'pro/subscription/confirm', payload, true), 'data', {});
const getCurrentLicense = async (): Promise<LicenseInterface> => _.get(await AxiosService.get(Config.server.api.paymentApi + 'pro/license', true), 'data', {});
const getPayments = async (): Promise<PaymentInterface[]> => _.get(await AxiosService.get(Config.server.api.paymentApi + 'pro/payment', true), 'data', {});
const getPlans = async (): Promise<Plan[]> => _.get(await AxiosService.get(Config.server.api.paymentApi + 'pro/plans', false), 'data', {})
const getPlanById = async (planId: string): Promise<Plan> => _.get(await AxiosService.get(Config.server.api.paymentApi + `pro/plan/${planId}`, true), 'data', {})
const stripeConnectOnboarding = async (): Promise<any> => _.get(await AxiosService.get(Config.server.api.paymentApi + 'pro/stripe/onboard', true), 'data', {})
const verifyStripeAccount = async (): Promise<AccountStatus> => _.get(await AxiosService.get(Config.server.api.paymentApi + 'pro/stripe/verify-account', true), 'data', {})

const exports = {
    cancelSubscription,
    createStripePaymentIntent,
    createPayment,
    createSubscription,
    confirmSubscription,
    getCurrentLicense,
    getPayments,
    getPlans,
    getPlanById,
    stripeConnectOnboarding,
    verifyStripeAccount
};

export default exports;